package com.anjuros.website.templates.template10.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.shared.MenuIcon
import com.anjuros.website.templates.template10.modules.Template10Section
import com.anjuros.website.templates.template10.modules.Template10Theme
import com.anjuros.website.templates.template10.styles.Template10ColorVar
import com.anjuros.website.templates.template10.styles.Template10NavItemStyle
import com.anjuros.website.templates.template10.styles.Template10WideContainerStyle
import com.anjuros.website.templates.template10.util.Template10CompanyDetails
import com.anjuros.website.templates.template10.util.Template10Glyphs
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template10Header(onMenuClicked: () -> Unit) {
    Row(
        modifier = Template10WideContainerStyle.toModifier()
            .padding(topBottom = 26.px),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Template10Logo()

        Template10Navigation(
            modifier = Modifier.displayIfAtLeast(Breakpoint.LG)
        )

        MenuIcon(
            modifier = Modifier
                .displayUntil(Breakpoint.LG)
                .cursor(Cursor.Pointer)
                .color(Template10Theme.Paper.rgb)
                .onClick { onMenuClicked() }
        )
    }
}

/** Red seal + company name. */
@Composable
fun Template10Logo(
    nameColor: CSSColorValue = Template10Theme.Paper.rgb
) {
    Link(
        modifier = Modifier.textDecorationLine(TextDecorationLine.None),
        path = "#home"
    ) {
        Row(
            modifier = Modifier.gap(14.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Template10Seal(
                glyph = Template10Glyphs.LOGO,
                size = 44,
                fontSize = 22
            )
            Span(
                attrs = Modifier
                    .template10HeadingFont()
                    .fontSize(24.px)
                    .fontWeight(FontWeight.Bold)
                    .letterSpacing(0.02.em)
                    .color(nameColor)
                    .toAttrs()
            ) {
                AnjurosText(Template10CompanyDetails.CLIENTS_COMPANY_INFO)
            }
        }
    }
}

@Composable
fun Template10Navigation(modifier: Modifier = Modifier) {
    Row(
        modifier = modifier.gap(32.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Template10Section.entries.forEach { section ->
            val isContact = section == Template10Section.Contact
            Link(
                modifier = Modifier.textDecorationLine(TextDecorationLine.None),
                path = section.path
            ) {
                Span(
                    attrs = Template10NavItemStyle.toModifier()
                        .setVariable(Template10ColorVar, Template10Theme.Coral.rgb)
                        .template10BodyFont()
                        .fontSize(15.px)
                        .fontWeight(FontWeight.SemiBold)
                        .then(
                            if (isContact) Modifier
                                .padding(bottom = 2.px)
                                .styleModifier {
                                    property("border-bottom", "1.5px solid ${Template10Theme.Coral.hex}")
                                }
                            else Modifier
                        )
                        .toAttrs()
                ) {
                    Text(LocalText(section.title))
                }
            }
        }
    }
}
